import {useEffect, useState} from 'react';
import { MapContainer, TileLayer, Popup, Polyline } from 'react-leaflet';
import ClipLoader from 'react-spinners/ClipLoader';

function Lanes({selection}) {

    
    const [points2, setpoints] = useState([]);
    const [loading, setLoading] = useState(false); // Track loading state


    let component;
    let colors;


    useEffect(() => {
      setLoading(true); // Start loading

      var url = '/api/roadtransport/road_part';
      
      fetch(url).then((res) =>
        res.json().then((res) => {
          var dataTable = []
          res.data.forEach((obj, i) => {
              obj.Coordinates.forEach((pos, i) => {
                
                let temp = pos[0]
                pos[0] = pos[1]
                pos[1] = temp
              })
              dataTable.push(obj)
          });
          
          // console.log("Here",dataTable)
          setpoints(dataTable)
          setLoading(false); // Stop loading once data is fetched
        
        })
      )
      .catch((error) => {
        console.log("Refetching data for Markers!")
      });
    }, []);

    

    let road_color;

    if(!loading) {
      
      return (
          <div className = "container" style = {{marginBottom: "5%"}}>
              <p style = {{color: "orange"}}>*Για περισσότερες πληροφορίες πατήστε πάνω στο οδικό τμήμα</p>
              <MapContainer center={[37.983810, 23.727539]} zoom={7} scrollWheelZoom={true} style={{height: "500px"}}>
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
                />
                {points2.map((points, index) => {


                  let popup_content;
                  switch (selection[0]) {
                    case "Οδικά Τμήματα: Αριθμός λωρίδων":
                      if(points["LanesPerDi"] === 1){
                        road_color = "blue";
                      }
                      else if(points["LanesPerDi"] === 2){
                       road_color ="green";
                      }
                      else if(points["LanesPerDi"] === 3){
                        road_color ="yellow";
                      }
                      else if(points["LanesPerDi"] === 4){
                        road_color ="orange";
                      }
                      else{
                        road_color ="red";
                      }

                      colors = [
                        { name: 'Αριθμός λωρίδων: 1', color: 'blue' },
                        { name: 'Αριθμός λωρίδων: 3', color: 'yellow' },
                        { name: 'Άλλο', color: 'red' },
                        { name: 'Αριθμός λωρίδων: 2', color: 'green' },
                        { name: 'Αριθμός λωρίδων: 4', color: 'orange' }
                      ];
                      component =  <table style = {{marginTop: "5%"}}>
                      <tbody>
                        {colors.map((color, index) => (
                          <tr key={index}>
                            <div
                              style={{
                                height: '5px',
                                background: color.color,
                                width: '50px',
                              }}
                            ></div>
                            <td>{color.name}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                      popup_content = <div>
                        <p>Μήκος: {points["LinkLength"].toFixed(2)} km</p>
                        <p>Λωρίδες: {points["LanesPerDi"]}</p>
                        <p>Ονομασία: {points["Name"]}</p>
                        <p>Διόδιο: {points["Tolls"]}</p>
                      </div>
                      break;
                      
                    case "Οδικά Τμήματα: Κυκλοφοριακός φόρτος (ΕΜΗΚ)":
                      if(points["CarVolume"] <= 225){
                        road_color = "blue";
                      }
                      else if(points["CarVolume"] < 500){
                       road_color ="green";
                      }
                      else if(points["CarVolume"] <  800){
                        road_color ="yellow";
                      }
                      else if(points["CarVolume"] < 1000){
                        road_color ="orange";
                      }
                      else{
                        road_color ="red";
                      }
                      
                      popup_content = <div>
                      <p>Μήκος: {points["LinkLength"].toFixed(2)} km</p>
                      <p>ΕΜΗΚ ΙΧ αυτ.: {points["CarVolume"]}</p>
                      </div>
                      break;

                    case "Οδικά Τμήματα: Ιεράρχηση":
                      if(points["Ierarchy"] === "Αυτοκινητόδρομος"){
                        road_color = "blue";
                      }
                      else if(points["Ierarchy"] === "Τοπική Οδός"){
                       road_color ="green";
                      }
                      else if(points["Ierarchy"] === "Επαρχιακή Οδός"){
                        road_color ="yellow";
                      }
                      else if(points["Ierarchy"] === "ΕΟ και ΠΕΟ ταχείας κυκ"){
                        road_color ="orange";
                      }
                      else{
                        road_color ="red";
                      }

                      
                      popup_content = <div>
                      <p>Ιεράρχηση: {points["Ierarchy"]}</p>
                      </div>
                      break;

                    case 'Οδικά Τμήματα: Ταχύτητα ελεύθερης ροής':
                      if(points["V0"] <= 30){
                        road_color = "blue";
                      }
                      else if(points["V0"] <= 50){
                       road_color ="green";
                      }
                      else if(points["V0"] <= 80){
                        road_color ="yellow";
                      }
                      else if(points["V0"] <= 100){
                        road_color ="orange";
                      }
                      else{
                        road_color ="red";
                      }

                      popup_content = <div>
                        <p>Ταχύτητα ελευθέρης ροής: {points["V0"].toFixed(2)}</p>
                        </div>
                        break;
                    case "Οδικά Τμήματα: Λόγος v/c":
                      if(points["V_C"] <= 0.01){
                        road_color = "blue";
                      }
                      else if(points["V_C"] <= 0.02){
                       road_color ="green";
                      }
                      else if(points["V_C"] <= 0.04){
                        road_color ="yellow";
                      }
                      else if(points["V_C"] <= 0.05){
                        road_color ="orange";
                      }
                      else{
                        road_color ="red";
                      }
                          popup_content = <div>
                          <p>Λόγος v/c: {points["V_C"].toFixed(2)}</p>
                          </div>
                        break;

                    case "Οδικά Τμήματα: Διανυθέντα οχηματοχιλιόμετρα":
                      if(points["Vehiclekms"] <= 30000.000){
                        road_color = "blue";
                      }
                      else if(points["Vehiclekms"] <= 60000.000){
                       road_color ="green";
                      }
                      else if(points["Vehiclekms"] <= 8000.000){
                        road_color ="yellow";
                      }
                      else if(points["Vehiclekms"] <= 100538.00){
                        road_color ="orange";
                      }
                      else{
                        road_color ="red";
                      }

                      
                      popup_content = <div>
                      <p>Διανυθέντα Οχηματοχιλιόμετρα: {points["Vehiclekms"].toFixed(2)} km</p>
                      </div>
                      break;

                    case "Οδικά Τμήματα: Διανυθέντες οχηματοώρες":

                    if(points["VehicleHou"] <= 30){
                      road_color = "blue";
                    }
                    else if(points["VehicleHou"] <= 50){
                     road_color ="green";
                    }
                    else if(points["VehicleHou"] <= 70){
                      road_color ="yellow";
                    }
                    else if(points["VehicleHou"] <= 100){
                      road_color ="orange";
                    }
                    else{
                      road_color ="red";
                    }
                      popup_content = <div>
                        <p>Διανυθέντες οχηματοώρες: {points["VehicleHou"].toFixed(2)}</p>
                        </div>
                      break;

                    default:
                      console.log('I do not recognize this.');
                  }

                  return (
                    <div key={index}>
                      
                      <Polyline pathOptions={{ weight: 5}} positions={points.Coordinates} color = {road_color} > 
                        <Popup autoClose={false}>{popup_content}</Popup>
                      </Polyline>
                    </div>
                  )
                })}
              </MapContainer>

              {component ? component : <></>}
          </div>
      );
    }
    else {
      return(
        <div className="container" style = {{marginLeft: "40%"}}>
          <ClipLoader size={100} color={'#123abc'} loading={true}/>
        </div>
      )
    }
    }



export default Lanes;